<template>
  <div>
    <!--  -->
    <CheckFormBox :title="$t('hzmbG.title.application')">
      <el-row :gutter="48" type="flex">
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.approveNo')">
            <span>{{ form.approveNo }}</span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbGInsurance.label.registrationType')">
            <span>
              {{
                HKVEHICLEREGISTERTYPE[form.registrationType]
                  | hkVehicleRegisterType
              }}
            </span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbGInsurance.label.admittanceStartDate')">
            <span>{{ form.admittanceStartDate | formatDT("dd/MM/yyyy") }}</span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbGInsurance.label.admittanceEndDate')">
            <span>{{ form.admittanceEndDate | formatDT("dd/MM/yyyy") }}</span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.registrationNo')">
            <span>{{ form.registrationNo }}</span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbGInsurance.label.identificationNo')">
            <span>{{ form.identificationNo }}</span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbGInsurance.label.noticePhone')">
            <span>{{ `+${form.authMobileAreaCode} ${form.authMobile}` }}</span>
          </CheckRowText>
        </el-col>
      </el-row>
    </CheckFormBox>
    <!--  -->
    <CheckFormBox :title="$t('hzmbGInsurance.title.boxTitle1')">
      <el-row :gutter="48" type="flex">
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbGInsurance.label.mainlandInsuranceNo')">
            <span>{{ form.mainlandInsuranceNo }}</span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText
            :label="$t('hzmbGInsurance.label.mainlandInsuranceStartDate')"
          >
            <span>
              {{ form.mainlandInsuranceStartDate | formatDT("dd/MM/yyyy") }}
            </span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText
            :label="$t('hzmbGInsurance.label.mainlandInsuranceEndDate')"
          >
            <span>
              {{ form.mainlandInsuranceEndDate | formatDT("dd/MM/yyyy") }}
            </span>
          </CheckRowText>
        </el-col>
      </el-row>
    </CheckFormBox>
    <!--  -->
    <template v-if="form.documents.length > 0">
      <div class="check_title">
        {{ $t("message.DataRegistration.check.already_upload_file") }}
      </div>
      <div class="check_file_list">
        <div
          v-for="(item, index) in form.documents"
          :key="item.id"
          class="check_file_list_content"
        >
          <div v-if="item.file">
            <span
              >{{ index + 1 }}.{{
                item.documentType &&
                item.documentType[`name${$t("message.lan")}`]
              }}：</span
            >
            <span class="check_file_name"
              >&nbsp;{{ item.file && item.file.filename }}</span
            >
          </div>
        </div>
      </div>
    </template>
    <!--  -->
    <div class="next_btn">
      <GradientBtn @click="back">{{ $t("message.back") }} </GradientBtn>
      <GradientBtn @click="onSubmit" :loading="submitLoading"
        >{{ $t("message.DataRegistration.check.submit") }}
      </GradientBtn>
    </div>
    <!--  -->
  </div>
</template>

<script>
import HzmbGInsuranceApplicationApi from "@/api/hzmb-gh/HzmbGInsuranceApplicationApi";
import CheckFormBox from "../../Check/components/CheckFormBox.vue";
import CheckRowText from "@/components/CheckRowText.vue";
import GradientBtn from "@/components/GradientBtn.vue";
import { HKVEHICLEREGISTERTYPE } from "@/enums";
import { registerType, hkVehicleRegisterType, driverSeat } from "@/filters";
import BaseParameterAPI from "@/api/hzmb-gh/BaseParameterAPI";

export default {
  components: { CheckFormBox, CheckRowText, GradientBtn },
  filters: { registerType, hkVehicleRegisterType, driverSeat },
  data() {
    return {
      serviceType: this.$route.meta.serviceType,
      applicationId: this.$route.query.applicationId,
      loading: false,
      submitLoading: false,
      form: {
        documents: [],
      },
      HKVEHICLEREGISTERTYPE,
    };
  },
  computed: {},
  created() {
    this.get();
    this.getBase();
  },
  methods: {
    //
    async get() {
      try {
        this.loading = true;
        let form = await HzmbGInsuranceApplicationApi.getById(
          this.applicationId
        );
        form.authMobileAreaCode = form.authMobile.slice(0, 3);
        form.authMobile = form.authMobile.slice(3);
        this.$set(this, "form", form);
      } catch (error) {
        if (error.code === "DUPLICATE_APPROVING_APPLICATION") {
          this.$alert(
            this.$t("message.ErrorMessage.DUPLICATE_APPROVING_APPLICATION")
          );
          this.$router.replace(`/hzmb-truck-hk`);
        } else {
          this.$error(error);
        }
      } finally {
        this.loading = false;
      }
    },
    //
    async getBase() {
      try {
        this.hongKongDrivingLicenseTypes =
          await BaseParameterAPI.getBaseParameter("HK_DRIVING_LICENSE_TYPE");
      } catch (error) {
        this.$error(error);
      }
    },
    //
    findByBase(value, data, name = "codeKey") {
      const obj = data.find((e) => e[name] === value);
      if (obj) return obj;
      else return { [this.localeAttr]: "-" };
    },
    //
    async onSubmit() {
      await this.$confirm(
        this.$t("message.confirm_submit_content"),
        this.$t("message.tips"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      );

      try {
        this.submitLoading = true;

        const { applicationNo } = await HzmbGInsuranceApplicationApi.submit(
          this.applicationId
        );

        this.$router.push({
          path: `/hzmb-g-insurance/success`,
          query: { applicationId: this.applicationId, applicationNo },
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    //
    back() {
      this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.check_drivers_title {
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(50, 50, 50, 1);
  line-height: 25px;
}
.el-row {
  align-items: flex-start;
}

.check_title {
  max-width: 867px;
  margin: auto;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #262626;
  border-bottom: 3px solid #38959d;
  padding: 16px 0;
}
.check_file_list {
  max-width: calc(867px - 48px);
  width: calc(100% - 48px);
  margin: 24px auto;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 1);
  padding: 24px;
}
.check_file_list_content {
  max-width: 760px;
  margin: auto;
  font-size: 16px;
  line-height: 22px;
}
.check_file_list_content + .check_file_list_content {
  margin-top: 24px;
}
.check_file_name {
  color: #5ba7ad;
}
</style>
